import './spacerBar.css';

export default function SpacerBar({width, offsetX, offsetY, thick, color, center}) {

    const isThick = thick ? '0.6rem' : '0.3rem';

    return (
        <div className="spacer-bar"
            style={{
                width: width,
                height: isThick,
                background: color,
                transform: `translateX(${offsetX})`,
                transform: `translateY(${offsetY})`,
                margin: center 
            }}
        />
    )
}